var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9836 5.44703C17.9836 5.456 17.9836 5.46415 17.978 5.47311L16.1551 13.9403C16.099 14.2384 15.9421 14.5074 15.7115 14.7008C15.4809 14.8943 15.1909 15.0001 14.8917 15H3.11156C2.81242 14.9999 2.52269 14.894 2.29223 14.7006C2.06177 14.5072 1.905 14.2383 1.84891 13.9403L0.0260767 5.47311C0.0260767 5.46415 0.0220582 5.456 0.0204507 5.44703C-0.0294383 5.16669 0.0125351 4.8775 0.139957 4.62364C0.26738 4.36977 0.473244 4.1652 0.726093 4.04118C0.978943 3.91716 1.26487 3.88051 1.54019 3.93683C1.81551 3.99315 2.06509 4.13934 2.25077 4.35307L4.95689 7.31132L7.83421 0.766326C7.83434 0.76361 7.83434 0.760889 7.83421 0.758174C7.9371 0.531839 8.10177 0.340143 8.30873 0.205776C8.51569 0.0714097 8.75628 0 9.00201 0C9.24774 0 9.48833 0.0714097 9.69529 0.205776C9.90226 0.340143 10.0669 0.531839 10.1698 0.758174C10.1697 0.760889 10.1697 0.76361 10.1698 0.766326L13.0471 7.31132L15.7533 4.35307C15.9393 4.14093 16.1886 3.99617 16.4631 3.94077C16.7377 3.88537 17.0226 3.92235 17.2746 4.04612C17.5265 4.16988 17.7318 4.37365 17.8592 4.62649C17.9865 4.87933 18.0291 5.16743 17.9804 5.44703H17.9836Z",
    fill: "#FFA200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.638cd46949ef183600c45159d1f3a7e9.svg";
export { ForwardRef as ReactComponent };